module.exports = __webpack_public_path__ + "img/logo.a5f0f5dd.png";